import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import { t } from '@lingui/macro'

import { PageWithSingleAlertAndBackToLogin } from '../../PageWithSingleAlert'

export const authFailureRouteExpression = '/authFailureCallback/:reason'

export const AuthFailed: React.FC = () => {
  const routeMatch = useRouteMatch<{ reason: string }>(
    authFailureRouteExpression
  )

  return (
    <PageWithSingleAlertAndBackToLogin
      description={decodeURIComponent(routeMatch?.params.reason ?? '')}
      title={t`SSO login failed`}
    />
  )
}
